// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"14adac6d","453":"56904ef6","455":"acce309a","977":"c8e38e56"}[chunkId] + ".chunk.js";
};